import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const CommunityLeaderEventPlansConductionReports = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Community leader's event plans, conduction, reports" />
    </Box>
  );
};
